import { HttpsUrl } from '../../types/HttpsUrl';

import {
  accountUrl,
  loungeUrl,
  portalUrl,
  nurseSquareUrl,
  knowledgeNurseSenkaUrl,
  workplaceReputationUrl,
  medicalTerm,
  surveyUrl,
  recruitUrl,
  jobNurseSenkaUrl as getJobNurseSenkaUrl,
  recruitNurseSenkaUrl as getRecruitNurseSenkaUrl,
  njbUrl as getNjbUrl,
  defaultProfileImageUrl as getDefaultProfileImageUrl,
  insuranceUrl as getInsuranceUrl,
  type AppEnv,
} from '@/packages/nurse-senka-frontend-sdk';

// 複数箇所で利用するURLはこのファイル内に定義する

export const accountWebUrl = (appEnv: AppEnv): HttpsUrl => accountUrl(appEnv);

export const portalWebUrl = (appEnv: AppEnv): HttpsUrl => portalUrl(appEnv);

export const loungeWebUrl = (appEnv: AppEnv): HttpsUrl => loungeUrl(appEnv);

export const squareWebUrl = (appEnv: AppEnv): HttpsUrl =>
  nurseSquareUrl(appEnv);

export const knowledgeWebUrl = (appEnv: AppEnv): HttpsUrl =>
  knowledgeNurseSenkaUrl(appEnv);

export const workplaceReputationWebUrl = (appEnv: AppEnv): HttpsUrl =>
  workplaceReputationUrl(appEnv);

export const medicalTermWebUrl = (appEnv: AppEnv): HttpsUrl =>
  medicalTerm(appEnv);

export const surveyWebUrl = (appEnv: AppEnv): HttpsUrl => surveyUrl(appEnv);

export const recruitWebUrl = (appEnv: AppEnv): HttpsUrl => recruitUrl(appEnv);

export const recruitNurseSenkaUrl = (appEnv: AppEnv): HttpsUrl =>
  getRecruitNurseSenkaUrl(appEnv);

export const jobNurseSenkaUrl = (appEnv: AppEnv): HttpsUrl =>
  getJobNurseSenkaUrl(appEnv);

export const njbUrl = (appEnv: AppEnv): HttpsUrl => getNjbUrl(appEnv);

export const memberRegistrationUrl = (appEnv: AppEnv): HttpsUrl =>
  `${accountWebUrl(appEnv)}/registrations`;

export const authorizationUrl = (appEnv: AppEnv): HttpsUrl =>
  `${accountWebUrl(appEnv)}/api/auth/authorization`;

export const myPageUrl = (appEnv: AppEnv): HttpsUrl => accountWebUrl(appEnv);

export const defaultProfileImageUrl = (appEnv: AppEnv): HttpsUrl =>
  getDefaultProfileImageUrl(appEnv);

export const termsOfUseUrl = (appEnv: AppEnv) =>
  `${portalWebUrl(appEnv)}/policies/terms`;

export const insuranceUrl = (appEnv: AppEnv): HttpsUrl =>
  getInsuranceUrl(appEnv);
